import { Text, View } from '@react-pdf/renderer'
import { PDFStyles } from 'pages/reporting/shared/pdfGeneration/styles/PDFStyles'
import React from 'react'

interface PageFooterProps {
  jobNumber?: string
  revisionNumber?: number
  sectionNumber?: number
  prelim?: boolean
}

export const PageFooter: React.FC<PageFooterProps> = ({
  jobNumber,
  revisionNumber,
  sectionNumber,
  prelim,
}) => {
  return (
    <View fixed style={PDFStyles.footerContainer}>
      <View style={PDFStyles.footerLine} />
      <View style={PDFStyles.footerContent}>
        <Text style={PDFStyles.footerJobNumber}>
          {jobNumber ? `Job Number: ${jobNumber}` : ''}
        </Text>

        <Text style={PDFStyles.footerRevisionInfo}>
          {sectionNumber
            ? `Section Number: ${sectionNumber.toFixed(1)} | `
            : ''}
          Report Revision: {prelim ? 'Preliminary' : revisionNumber || ''}
        </Text>

        <Text
          style={PDFStyles.footerPageNumber}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
        />
      </View>
    </View>
  )
}
